module.exports = __webpack_public_path__ + "media/images/flags/1x1/cub-60ebc20f4997e91781fc8b080922c86e.svg";